module.exports = __webpack_public_path__ + "static/img/Anvisionlogo.88dcd92a.png";